import {useNavigate} from 'react-router-dom'

//function Formulaire({children,title,handleMouse,handleMouseleave,handlekeyUpgain,onclick,count,setCount,nom,postnom,prenom,sexe,telephone,Image,setNom,setPostnom,setPrenom,setSexe,setImage,setTelephone,setNomcomplet}){
    function Formulaire({Alert_confirm_submit,id,classes,my_classe,setMy_classe,error_submission,submission,HandleSubmit,children,title,handleMouse,handleMouseleave,handlekeyUpgain,onclick,nom,postnom,prenom,sexe,date_naissance,lieu_naissance,setNom,setPostnom,setPrenom,setSexe,setDate_naissance,setLieu_naissance,setNom_complet,numero_serni,setNumero_serni,adresse,setAdresse}){
        const navigate=useNavigate()
        const modif=id!==undefined?true:false;
    return(
    <>
       <div className="container py-5">
    <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
            {/* Carte principale */}
            <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                <div className="card-header bg-primary py-4 text-center">
                    <h3 className="text-white fw-bold mb-0">{title}</h3>
                    <p className="text-white-50 small mb-0">Veuillez remplir tous les champs obligatoires</p>
                </div>

                <div className="card-body p-4 p-md-5">
                    <form>
                        {/* SECTION 1 : IDENTITÉ */}
                        <h5 className="text-primary fw-bold mb-4 border-bottom pb-2">1. Identité de l'élève</h5>
                        <div className="row g-3 mb-4">
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Nom</label>
                                <input type="text" className="form-control form-control-lg bg-light border-0 shadow-sm" value={nom} onChange={(e)=>setNom(e.target.value.toLowerCase())} onBlur={()=>setNom_complet(`${nom} ${postnom} ${prenom}`)} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Postnom</label>
                                <input type="text" className="form-control form-control-lg bg-light border-0 shadow-sm" value={postnom} onChange={(e)=>setPostnom(e.target.value.toLowerCase())} onBlur={()=>setNom_complet(`${nom} ${postnom} ${prenom}`)} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Prénom</label>
                                <input type="text" className="form-control form-control-lg bg-light border-0 shadow-sm" value={prenom} onChange={(e)=>setPrenom(e.target.value.toLowerCase())} onBlur={()=>setNom_complet(`${nom} ${postnom} ${prenom}`)} />
                            </div>
                        </div>

                        {/* SECTION 2 : NAISSANCE & GENRE */}
                        <h5 className="text-primary fw-bold mb-4 border-bottom pb-2">2. État Civil & Scolarité</h5>
                        <div className="row g-3 mb-4">
                            <div className="col-md-3">
                                <label className="form-label fw-semibold">Genre</label>
                                <select className="form-select form-select-lg bg-light border-0 shadow-sm" value={sexe} onChange={(e)=>setSexe(e.target.value)}>
                                    <option value="" disabled>Choisir...</option>
                                    <option value="M">Homme</option>
                                    <option value="F">Femme</option>
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label fw-semibold">Date de Naissance</label>
                                <input type="date" className="form-control form-control-lg bg-light border-0 shadow-sm" value={date_naissance} onChange={(e)=>setDate_naissance(e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Lieu de Naissance</label>
                                <input type="text" className="form-control form-control-lg bg-light border-0 shadow-sm" value={lieu_naissance} onChange={(e)=>setLieu_naissance(e.target.value.toLowerCase())} />
                            </div>
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Classe</label>
                                <select className="form-select form-select-lg bg-light border-0 shadow-sm" value={my_classe} onChange={(e)=>setMy_classe(e.target.value)}>
                                    <option value="" disabled>Choisir la classe...</option>
                                    {classes.map(cla => <option value={cla.id} key={cla.id}>{cla.nom}</option>)}
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Numéro Serni</label>
                                <input type="text" className="form-control form-control-lg bg-light border-0 shadow-sm" value={numero_serni} onChange={(e)=>setNumero_serni(e.target.value)} />
                            </div>
                        </div>

                        {/* SECTION 3 : CONTACT */}
                        <h5 className="text-primary fw-bold mb-4 border-bottom pb-2">3. Localisation</h5>
                        <div className="row mb-4">
                            <div className="col-12">
                                <label className="form-label fw-semibold">Adresse Résidentielle complète</label>
                                <textarea rows="2" className="form-control bg-light border-0 shadow-sm" value={adresse} onChange={(e)=>setAdresse(e.target.value.toLowerCase())}></textarea>
                            </div>
                        </div>

                        {/* MESSAGES D'ALERTE */}
                        {error_submission && (
                            <div className="alert alert-danger border-0 shadow-sm d-flex align-items-center mb-4">
                                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                Veuillez compléter tous les champs obligatoires.
                            </div>
                        )}
                        {submission && (
                            <div className="alert alert-success border-0 shadow-sm d-flex align-items-center mb-4">
                                <i className="bi bi-check-circle-fill me-2"></i>
                                L'élève a été enregistré avec succès !
                            </div>
                        )}

                        {/* BOUTON D'ACTION */}
                        <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-5">
                            <button type="button" className="btn btn-outline-secondary px-5 rounded-pill" onClick={()=>navigate("/Elèves")}>Annuler</button>
                            {
                               modif ? <button type="button" className="btn btn-warning px-5 rounded-pill shadow-lg fw-bold" onClick={Alert_confirm_submit}>Mettre à jour</button> :
                               <button type="button" className="btn btn-primary px-5 rounded-pill shadow-lg fw-bold" onClick={HandleSubmit}>
                                Enregistrer l'élève
                            </button>
                            }
                            
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</>
    )
}
export default Formulaire;